import { Inject, Injectable } from '@angular/core';
import { CognitoCallback, CognitoUtil, ResendCodeCallback } from './cognito.service';
import { AuthenticationDetails, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { Register } from '../app/models/register';
import { UpdatePassword } from '../app/models/updatepassword';
import * as AWS from 'aws-sdk/global';

@Injectable()
export class UserRegistrationService {

    _user: Register = null;

    constructor(@Inject(CognitoUtil) public cognitoUtil: CognitoUtil) {

    }

    register(user: Register, callback: CognitoCallback): void {

        this._user = user;
        const attributeList = [];

        const dataEmail = {
            Name: 'email',
            Value: user.Email
        };
        let processedPhone = `+1${user.PhoneNumber.replace(/[-+()\s]/g, '')}`;
        const dataPhone = {
            Name: 'phone_number',
            Value: processedPhone
        };
        const dataFamilyName = {
            Name: 'custom:LastName',
            Value: user.LastName
        };
        const dataGivenName = {
            Name: 'custom:FirstName',
            Value: user.FirstName
        };

        let paramsString = localStorage.getItem('TrackingParameters');

        if (paramsString && paramsString.length <= 2048)
        {
            const dataGivenTracking = {
                Name: 'custom:trackingparameters',
                Value: paramsString
            };
            attributeList.push(new CognitoUserAttribute(dataGivenTracking));
        }

        attributeList.push(new CognitoUserAttribute(dataEmail));
        attributeList.push(new CognitoUserAttribute(dataPhone));
        attributeList.push(new CognitoUserAttribute(dataFamilyName));
        attributeList.push(new CognitoUserAttribute(dataGivenName));

        this.cognitoUtil.getUserPool().signUp(user.Email, user.Password, attributeList, null, function (err, result) {
            if (err) {
                callback.cognitoCallback(err.message, null);
            } else {
                console.log('UserRegistrationService: registered user is ' + result);              
                callback.cognitoCallback(null, result);
            }
        });

    }

    confirmRegistration(username: string, confirmationCode: string, callback: CognitoCallback): void {

        const userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        const cognitoUser = new CognitoUser(userData);

        cognitoUser.confirmRegistration(confirmationCode, true, function (err, result) {
            if (err) {
                callback.cognitoCallback(err.message, null);
            } else {
                callback.cognitoCallback(null, result);
            }
        });
    }

    resendCode(username: string, callback: ResendCodeCallback): void {
        const userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        const cognitoUser = new CognitoUser(userData);

        cognitoUser.resendConfirmationCode(function (err, result) {
            if (err) {
                callback.resendCodeCallback(err.message, null);
            } else {
                callback.resendCodeCallback(null, result);
            }
        });
    }

    newPassword(newPasswordUser: UpdatePassword, callback: CognitoCallback): void {
        // Get these details and call
        // cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, this);
        const authenticationData = {
            Username: newPasswordUser.Email,
            Password: newPasswordUser.ExistingPassword,
        };
        const authenticationDetails = new AuthenticationDetails(authenticationData);

        const userData = {
            Username: newPasswordUser.Email,
            Pool: this.cognitoUtil.getUserPool()
        };

        const cognitoUser = new CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                // User was signed up by an admin and must provide new
                // password and required attributes, if any, to complete
                // authentication.

                // the api doesn't accept this field back
                delete userAttributes.email_verified;

                cognitoUser.completeNewPasswordChallenge(newPasswordUser.Password, requiredAttributes, {
                    onSuccess: function (result) {
                        callback.cognitoCallback(null, userAttributes);
                    },
                    onFailure: function (err) {
                        callback.cognitoCallback(err.message, null);
                    }
                });
            },
            onSuccess: function (result) {
                callback.cognitoCallback(null, result);
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            }
        });
    }
}
